import BasePriceHandler from './base';

export default class VariantPriceHandler extends BasePriceHandler {
  handle = (data, node) => {
    const {
      price,
      subscriptionPrice,
      servings,
      otpDiscount,
      productId,
      disablePricePrecision
    } = data;

    const selectors = this.selectors(node);
    const subscriptionState = selectors.getSubscriptionState();
    const quantity = selectors.getQuantity();

    this.updatePrice(
      price,
      subscriptionPrice,
      servings,
      subscriptionState,
      quantity,
      node,
      otpDiscount,
      JSON.parse(disablePricePrecision),
      productId
    );
  };
}
